module.exports = __webpack_public_path__ + "static/olatosi-211a3f438dbf91cdc48fe471be6ae60f.png";